import{jsx as t}from"react/jsx-runtime";import{memo as e}from"react";import{styled as i}from"styled-components";const o=i.option`
  height: 19px;
  line-height: 22px;
  margin: 0 5px 0 0.5px;
  vertical-align: middle;
`,r=e((function({optionValue:e,displayValue:i}){return t(o,{value:e,children:i})}));export{r as Option};
